<template>
  <div id="app">
    <router-view :mobile="isMobile" :desktop="isDesktop" :tablet="isTablet"></router-view>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  data() {
    return {
      isMobile: false,
      isTablet: false,
      isDesktop: false,
    }
  },
  // components: {
  //   HelloWorld
  // },
  created() {
    window.addEventListener('resize', this.handleResize);
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    if (window.innerWidth >= 768 && window.innerWidth <= 992) {
      this.isTablet = true;
    }
    if (window.innerWidth > 992) {
      this.isDesktop = true;
    }
  },
  mounted() {
    this.isLoading = false;
  },
  computed: {
  },
  methods: {
    handleResize() {
      this.isMobile = (window.innerWidth < 768) ? (window.innerWidth < 768) : false;
      this.isTablet = (window.innerWidth >= 768) &&
      (window.innerWidth <= 992) ? (window.innerWidth >= 768) && (window.innerWidth <= 992) : false;
      this.isDesktop = (window.innerWidth > 992) ? (window.innerWidth > 992) : false;
    },
  },
}
</script>

<style lang="scss">
  @import './src/scss/config.paths';
  @import './src/scss/lib/include-media';
  @import './src/scss/config.variables';
  @import './src/scss/config.functions';
  @import './src/scss/config.font-faces';
  // @import './src/scss/lib/ionicons/ionicons';
  @import './src/scss/config.mediaqueries';
  @import './src/scss/lib/bootstrap-grid-framework';
  @import './src/scss/lib/bootstrap-grid';
  @import './src/scss/config.grid';
  @import './src/scss/library.colors';
  @import './src/scss/library.general';
  // @import './src/scss/library.display';
  @import './src/scss/library.tools';
  @import './src/scss/library.type-styles';
  @import './src/scss/library.type-defaults';
  @import './src/scss/module.blocks';
</style>
